module.exports = __webpack_public_path__ + "img/cloud.055b5272.png";